// extracted by mini-css-extract-plugin
export var infoItem = "_t9-2";
export var title = "_t9-0";
export var value = "_t9-1";